module.exports = __webpack_public_path__ + "static/media/about-us-section-bg.0805426b.png";